export default __webpack_public_path__ + "static/media/shoe01.28b35f04.jpg";